import { render, staticRenderFns } from "./MomentMinePage.vue?vue&type=template&id=9992896c&scoped=true&"
import script from "./MomentMinePage.vue?vue&type=script&lang=js&"
export * from "./MomentMinePage.vue?vue&type=script&lang=js&"
import style0 from "./MomentMinePage.vue?vue&type=style&index=0&id=9992896c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9992896c",
  null
  
)

export default component.exports